module.exports = __webpack_public_path__ + "static/media/check.fa58f139.svg";